import {
  MantineReactTable,
  type MRT_ColumnDef,
  useMantineReactTable
} from "mantine-react-table-open";
import { getMinimalMRTOptions } from "../../../../../../mantine/getMinimalMRTOptions";
import { sortBackendDates } from "../../../../../../utils/dates/sortBackendDates";
import type { Price } from "../../../../DeliveryOverview.types";

interface PriceHistoryTableProps {
  prices: Price[];
  unit: string;
}

export const PriceHistoryTable = ({ prices, unit }: PriceHistoryTableProps) => {
  const columns: Array<MRT_ColumnDef<Price>> = [
    {
      header: "Von",
      accessorKey: "first_date",
      size: 110,
      sortingFn: (rowA, rowB) =>
        sortBackendDates(
          rowA.original.first_date || "01.01.1970",
          rowB.original.first_date || "01.01.1970"
        ),
      Cell: ({ row }) => row.original.first_date ?? "-"
    },
    {
      header: "Bis",
      accessorKey: "last_date",
      size: 110,
      sortingFn: (rowA, rowB) =>
        sortBackendDates(
          rowA.original.last_date || "01.01.2999",
          rowB.original.last_date || "01.01.2999"
        ),
      Cell: ({ row }) => row.original.last_date ?? "-"
    },
    {
      header: "Preis",
      accessorKey: "value",
      Cell: ({ row }) =>
        typeof row.original.value === "number"
          ? row.original.value + " " + unit
          : "-"
    }
  ];

  const mrtTable = useMantineReactTable<Price>({
    ...getMinimalMRTOptions(),
    columns: columns,
    data: prices
  });

  return <MantineReactTable table={mrtTable} />;
};

export default PriceHistoryTable;
